import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.JPG'
import pic1 from './pic1.JPG'
import pic2 from './pic2.JPG'
import pic3 from './pic3.JPG'
import pic4 from './pic4.JPG'
import pic5 from './pic5.JPG'
import pic6 from './pic6.jpg'
import pic7 from './pic7.JPG'
import pic8 from './pic8.JPG'
import pic9 from './pic9.JPG'
import pic10 from './pic10.JPG'


const Id2 = () => {

    const detail = 
        {
            id:36,
            imgSrc:cover,
            ini:'USTH and IRD (via IJL DRISA & PRESTO) Host Specialized Bioinformatics Training to Strengthen Research Capacity Across Southeast Asia',
            href:'..//pages/news/others/USTH_bioinformatics_vietnam/index.js',
            element:'',
            topic:``,
            inform:`The Department of Life Sciences at the University of Science and Technology of Hanoi (USTH), in collaboration with the French National Research Institute for Sustainable Development (IRD) through its International Joint Laboratories DRISA and PRESTO, organized a specialized bioinformatics training course to strengthen the research capacity of early-career researchers, faculty members, and students across Southeast Asia. The course took place from October 19 to 23, 2026, at USTH, Vietnam Academy of Science and Technology, Hanoi, Vietnam. 
                    <br><br>The workshop brought together distinguished experts: Dr. Tam Thi Thanh Tran (USTH, Hanoi, Vietnam); Dr. Juliette Hayer (IJL DRISA, IRD, UMR MIVEGEC, France); Dr. Jacques Dainat (IRD, UMR MIVEGEC, France); Dr. Jean-Christophe Auguet (CNRS, UMR MARBEC, France); Dr. Dorothée Missé (IJL PRESTO, UMR MIVEGEC, IRD); Dr. Praveen Rahi (Institut Pasteur du Cambodge, Phnom Penh, Cambodia); Mr. Mathis Arnal (IJL PRESTO, UMR MIVEGEC, IRD); and Assoc. Prof. Nguyen Quang Huy (USTH, Hanoi, Vietnam). They shared in-depth insights and hands-on bioinformatics data analysis skills tailored to research in infectious disease ecology, marking a significant step in strengthening international research collaboration and networks across the region.`,
            link1:`https://lucent.ams.cmu.ac.th/view_activity.html?id=59`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
        {
            imageSrc: pic7,
            alt: 'pic7',
            title: 'pic7',
            thumbnailImageSrc: pic7
        },
        {
            imageSrc: pic8,
            alt: 'pic8',
            title: 'pic8',
            thumbnailImageSrc: pic8
        },
        {
            imageSrc: pic9,
            alt: 'pic9',
            title: 'pic9',
            thumbnailImageSrc: pic9
        },
        {
            imageSrc: pic10,
            alt: 'pic10',
            title: 'pic10',
            thumbnailImageSrc: pic10
        },
        
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id2;
